import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CreateTaskResponse, Task, TaskAddRequest, TaskTypeToCreate, TaskTypeToList } from '../models/task.model';
import { plainToInstance } from 'class-transformer';
import { TaskFormFilter } from '../models/task-form-filter.model';
import { MessageFormFilter } from '../models/message-form-filter.model';
import { TaskMessage } from '../models/message.model';

@Injectable({
  providedIn: 'root'
})
export class TaskService {

  private apiUrl = `${environment.sgcApi}`;
  private taskRoute = 'task';
  private messageRoute = 'message';

  constructor(
    private httpClient: HttpClient
  ) {}

  getTaskTypesToList() : Observable<TaskTypeToList[]> {
    let endpoint = `${this.apiUrl}${this.taskRoute}/types/toList`;
    return this.httpClient.get<TaskTypeToList[]>(endpoint).pipe(map((tasks) => {
      return plainToInstance(TaskTypeToList, tasks as TaskTypeToList[]);
    }));
  }

  getTaskTypesToCreate() : Observable<TaskTypeToCreate[]> {
    let endpoint = `${this.apiUrl}${this.taskRoute}/types/toCreate`;
    return this.httpClient.get<TaskTypeToCreate[]>(endpoint).pipe(map((tasks) => {
      return plainToInstance(TaskTypeToCreate, tasks as TaskTypeToCreate[]);
    }));
  }

  getTasks(filter: TaskFormFilter) : Observable<Task[]> {
    let endpoint = `${this.apiUrl}${this.taskRoute}${this.getTaskFilters(filter)}`;
    return this.httpClient.get<Task[]>(endpoint).pipe(map((tasks) => {
      return plainToInstance(Task, tasks as Task[]);
    }));
  }

  getMessages(filter: MessageFormFilter): Observable<TaskMessage[]> {
    let endpoint = `${this.apiUrl}${this.messageRoute}${this.getMessageFilters(filter)}`;
    return this.httpClient.get<TaskMessage[]>(endpoint).pipe(map((messages) => {
      return plainToInstance(TaskMessage, messages as TaskMessage[]);
    }));
  };

  private getTaskFilters(filter: TaskFormFilter) {
    let urlFilter = '?filters=';
    urlFilter += filter.date ? 'dateFrom=' + filter.date + ';'  : '';
    urlFilter += filter.taskTypeId ? 'taskTypeId=' + filter.taskTypeId + ';'  : '';
    urlFilter += filter.zoneId ? 'zoneId=' + filter.zoneId.toString() + ';' : '';
    urlFilter += filter.profitCenterCode != '' ? 'profitCenterCode=' + filter.profitCenterCode + ';' : '';
    urlFilter += filter.schoolId ? 'schoolId=' + filter.schoolId.toString() + ';' : '';
    urlFilter += filter.taskStatusId ? 'status=' + filter.taskStatusId.toString() + ';' : '';
    return urlFilter;
  }

  private getMessageFilters(filter: MessageFormFilter) {
    let urlFilter = '?filters=';
    urlFilter += filter.date ? 'dateFrom=' + filter.date + ';'  : '';
    urlFilter += filter.eventGuid ? 'eventGuid=' + filter.eventGuid + ';'  : '';
    urlFilter += filter.messageStatusId ? 'statusCode=' + filter.messageStatusId.toString() + ';' : '';
    return urlFilter;
  }

  createTask(task: TaskAddRequest, user: string) {
    let endpoint = `${this.apiUrl}${this.taskRoute}/user/${user}/massive`;
    return this.httpClient.post<CreateTaskResponse[]>(endpoint, task).pipe(
      map(data => data)
    );
  }
}
